import { useState, useEffect } from "react";
import { syncHubSpotData, syncEstimateRecord } from "../../utils/hubspotSync";
import CoverSheetPanel from "../turnover/CoverSheetPanel";

export default function EstCoverSheet({ project, bidPkg }) {
  const [hsCompanies,   setHsCompanies]   = useState([]);
  const [hsContacts,    setHsContacts]    = useState([]);
  const [hsLineItems,   setHsLineItems]   = useState([]);
  const [hsLoading,     setHsLoading]     = useState(false);
  const [cacheTime,     setCacheTime]     = useState(null);
  const [freshDealOwner,      setFreshDealOwner]      = useState(null);
  const [freshDealOwnerEmail, setFreshDealOwnerEmail] = useState(null);
  const [freshEstimator,      setFreshEstimator]      = useState(null);
  const [freshStage,          setFreshStage]          = useState(null);
  const [freshProjectType,    setFreshProjectType]    = useState(null);
  const [hsDealDescription,   setHsDealDescription]   = useState(null);
  const [hsSquareFeet,        setHsSquareFeet]        = useState(null);

  async function loadHubSpot() {
    if (!project?.HubSpotDealID) return;
    setHsLoading(true);
    try {
      const [data, fresh] = await Promise.all([
        syncHubSpotData(project.HubSpotDealID, null, null),
        syncEstimateRecord(project.HubSpotDealID, project?.ProjectID),
      ]);
      setHsCompanies(data?.companies     || []);
      setHsContacts(data?.contacts      || []);
      setHsLineItems(data?.lineItems    || []);
      setHsDealDescription(data?.dealDescription || null);
      setHsSquareFeet(data?.squareFeet  || null);
      setCacheTime(new Date().toISOString());
      if (fresh) {
        setFreshDealOwner(fresh.dealOwnerName);
        setFreshDealOwnerEmail(fresh.dealOwnerEmail);
        setFreshEstimator(fresh.estimatorName);
        setFreshStage(fresh.stageName);
        setFreshProjectType(fresh.projectType);
      }
    } catch (e) {
      console.error("HubSpot load failed:", e);
    } finally {
      setHsLoading(false);
    }
  }

  useEffect(() => { loadHubSpot(); }, [project?.HubSpotDealID]);

  // Map project fields to the turnover shape CoverSheetPanel expects
  const turnover = {
    ProjectName:      project?.ProjectName,
    HubSpotDealID:    project?.HubSpotDealID,
    JobNumber:        null,
    PlannedTurnoverDate: null,
    Market:           null,
    ProjectType:      freshProjectType    ?? project?.ProjectType,
    SquareFeet:       hsSquareFeet        ?? bidPkg?.ProjectSF ?? null,
    DealAmount:       null,
    LeadSource:       null,
    LeadSourceDetail: null,
    DealDescription:  hsDealDescription   ?? bidPkg?.SpecialRequirements ?? null,
    Salesperson:      freshDealOwner      ?? project?.DealOwner,
    SalespersonEmail: freshDealOwnerEmail ?? null,
    SalesRep2:        null,
    Estimator:        freshEstimator      ?? project?.AssignedEstimator,
    ContractStructure: null,
    LaborStrategy:    null,
    ArchMaterials:    null,
    Status:           freshStage          ?? project?.Status,
  };

  return (
    <CoverSheetPanel
      readOnly
      turnover={turnover}
      hsCompanies={hsCompanies}
      hsContacts={hsContacts}
      hsLineItems={hsLineItems}
      hsLoading={hsLoading}
      hsCacheTime={cacheTime}
      onRefreshHubSpot={loadHubSpot}
      // turnover-only props — unused when readOnly
      sections={[]}
      activeSection={{}}
      coverForm={{ commission_splits: [] }}
      setCover={() => {}}
      coverDirty={false}
      savingCover={false}
      pmList={[]}
      pmListLoading={false}
      directoryFailed={false}
      isAssignedOwner={() => false}
      getCoverSheetMissing={() => []}
      onToggleComplete={() => {}}
      onSave={() => {}}
      onCancel={() => {}}
      addCommissionRow={() => {}}
      updateCommissionRow={() => {}}
      removeCommissionRow={() => {}}
      goToSection={() => {}}
    />
  );
}
